import type { OnboardingInfo, SaveData } from '@/domains/onboarding/types';

export interface OnboardingService {
    save(data: SaveData): Promise<boolean>;
    info(): Promise<OnboardingInfo>;
}

export const OnboardingService = Symbol('OnboardingService');
